import React, { useContext, useState } from "react";
import { DynamicFormFieldProps } from "Modules/DynamicForm/types";
import { Form, Input, Row, Col } from "antd";
import { formItemProps } from "../../utils/formItemProps";
import style from "./MobileNumber.module.scss";
import classNames from "classnames";
import { DynamicFormContext } from "Modules/DynamicForm/store";

const DynamicFormMobileNumber = (props: DynamicFormFieldProps) => {
  const { alias, fieldID, fieldProps, onChangeValue, suffix } = props;
  const { staticPrefix } = fieldProps;
  const [value, setValue] = useState("");
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeValue?.(fieldID, e.currentTarget.value);
    setValue(e.currentTarget.value);
  };

  const handleFocus = () => {
    trackView(alias, value);
  };

  const handleBlur = () => {
    trackEdit(alias, value);
  };

  const { className, label, ...rest } = formItemProps(props);
  const { trackView, trackEdit } = useContext(DynamicFormContext);

  return (
    <Form.Item label={label} className={classNames(style.textfield, className)}>
      <Input.Group size="large">
        <Row gutter={8}>
          <Col flex="70px">
            <Input value={staticPrefix} disabled />
          </Col>
          <Col flex="1 1">
            <Form.Item {...rest}>
              <Input
                type="text"
                placeholder={fieldProps.placeholder}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                disabled={!fieldProps.editable}
                maxLength={fieldProps.maxChar}
                suffix={suffix}
              />
            </Form.Item>
          </Col>
        </Row>
      </Input.Group>
    </Form.Item>
  );
};

export default DynamicFormMobileNumber;
